import React from "react";
import { useNavigate } from "react-router";
import Header from '../../../components/Header';
import getToken from '../../../getters/getToken';
import postProductItem from "../../../requests/product/item/post";
import SaveButton from "./SaveButton";
import useAlerts from "../../../hooks/useAlerts";

const HeaderVirt = ({use_products, stateFields, photos}) => {
  const token = getToken();
  const navigate = useNavigate();
  const alerts = useAlerts();

  const isDisabled = () => {
    if (use_products.length === 1 && use_products[0].count > 1) {
      let result = !(stateFields?.name && stateFields?.articles.length > 0 && stateFields?.categoryId && String(stateFields?.price).length > 0);
      return result
    } else {
      let result = !(use_products.length > 1 && (stateFields?.name && stateFields?.articles.length > 0 && stateFields?.categoryId && String(stateFields?.price).length > 0))
      return result
    }
  }

  const createComplect = () => {
    let product = {
      ...stateFields,
      photos: photos,
      child_products: use_products,
    };

    postProductItem(token, product)
        .then((product) => {
          if (product.result === false) {
            alerts({variant: "error", message: `${product.error}`, autoHideDuration: 5000});
          } else {
            navigate("/product/edit/" + product.id, {replace: true});
          }
        })
        .catch(({message}: Error) => {
          alerts({
            message: message,
            variant: "error",
            autoHideDuration: 5000,
          });
        });
  }

  return (
    <Header 
      title={'Создание виртуальных комплектов'} 
      buttonBack={{ href: true }} 
      buttons={[
        [<SaveButton isDisabled={isDisabled()} handlerClick={createComplect} />],
      ]}/>
  )
}

export default HeaderVirt